'use strict';
define(['angular', 'app'], function (angular, app) {
    app.directive('googlePlusSignin', ['$window', '$timeout', '$rootScope', function ($window, $timeout, $rootScope) {
        var ending = /\.apps\.googleusercontent\.com$/;
        var oauthClient = null;

        return {
            restrict: 'E',
            transclude: true,
            template: '<span></span>',
            replace: true,
            link: function (scope, element, attrs, ctrl, linker) {
                attrs.clientid += (ending.test(attrs.clientid) ? '' : '.apps.googleusercontent.com');
                attrs.$set('data-clientid', attrs.clientid);
                attrs.$set('theme', attrs.theme);

                // Some default values, based on prior versions of this directive
                var defaults = {
                    onsuccess: googleSigninSuccess,
                    onfailure: googleSigninFailure,
                    cookiepolicy: 'single_host_origin',
                    scope: 'profile email',
                    height: 'standard',
                    width: 'wide',
                    access_type: 'online',
                    longtitle: true,
                    state: ''
                };

                defaults.clientid = attrs.clientid;
                defaults.theme = attrs.theme;

                // Overwrite default values if explicitly set
                angular.forEach(Object.getOwnPropertyNames(defaults), function (propName) {
                    if (attrs.hasOwnProperty(propName)) {
                        defaults[propName] = attrs[propName];
                    }
                });

                // Default language
                // Supported languages: https://developers.google.com/+/web/api/supported-languages
                attrs.$observe('language', function (value) {
                    $window.___gcfg = {
                        lang: value ? value : 'en'
                    };
                });

                var formatButton = function () {
                    $timeout(function () {
                        angular.element('span[customtargetid="st-btn-signin-google"]').find('span[id^="not_signed"], span[id^="connected"]').html('<span class="font-bold st-blue">Google</span>');
                    }, 500);
                };

                function reportGoogleError(error) {
                    // Google's legacy SDK may reject with plain objects. Reporting
                    // through console.error would trigger the webpack error overlay.
                    if ($window.console && $window.console.warn) {
                        $window.console.warn(
                            'Google Sign-In is temporarily unavailable.',
                            error && error.message || error || ''
                        );
                    }
                    scope.$emit('event:google-plus-signin-unavailable', error);
                }

        function broadcastSuccess(accessToken) {
            $rootScope.$broadcast('event:google-plus-signin-success', accessToken);
                }

        function broadcastFailure(response) {
            $rootScope.$broadcast('event:google-plus-signin-failure', response);
        }

        function requestGoogleLogin() {
            if (!oauthClient || typeof oauthClient.requestAccessToken !== 'function') {
                reportGoogleError(new Error('Google Identity Services is not ready'));
                return;
            }
            oauthClient.requestAccessToken({prompt: 'select_account'});
        }

        function initializeGoogleAuth() {
                    try {
                var oauth2 = $window.google &&
                    $window.google.accounts &&
                    $window.google.accounts.oauth2;

                if (!oauth2 || typeof oauth2.initTokenClient !== 'function') {
                    throw new Error('Google Identity Services unavailable');
                        }

                oauthClient = oauth2.initTokenClient({
                    client_id: attrs.clientid,
                    scope: 'openid email profile',
                    callback: function (response) {
                        if (response && response.access_token) {
                            broadcastSuccess(response.access_token);
                            return;
                        }
                        broadcastFailure(response || {error: 'google_auth_cancelled'});
                    }
                        });
                    } catch (error) {
                        reportGoogleError(error);
                    }
                }

                linker(function (el) {
            function loadGoogleSdk() {
                        if (el.length) {
                            element.append(el);
                        }
                element.on('click', requestGoogleLogin);
                        initializeGoogleAuth();
                formatButton();
                    }

            if ($window.google && $window.google.accounts && $window.google.accounts.oauth2) {
                        loadGoogleSdk();
                        return;
                    }

                    var existing = document.querySelector(
                'script[src="https://accounts.google.com/gsi/client"]'
                    );
                    if (existing) {
                        existing.addEventListener('load', loadGoogleSdk, {once: true});
                        existing.addEventListener('error', reportGoogleError, {once: true});
                        return;
                    }

                    var po = document.createElement('script');
                    po.type = 'text/javascript';
                    po.async = true;
            po.src = 'https://accounts.google.com/gsi/client';
                    po.onload = loadGoogleSdk;
                    po.onerror = reportGoogleError;
                    var firstScript = document.getElementsByTagName('script')[0];
                    firstScript.parentNode.insertBefore(po, firstScript);
                });
            }
        }
    }]).run(['$window', '$rootScope', function ($window, $rootScope) {
        $window.googleSigninSuccess = function (authResult) {
            var auth = authResult.getAuthResponse(true);
            $rootScope.$broadcast('event:google-plus-signin-success', auth.access_token);
        }

        $window.googleSigninFailure = function (authResult) {
            $rootScope.$broadcast('event:google-plus-signin-failure', authResult);
        }
    }]);

});
